//ruta del archivo src\app\config
import { environment } from "src/environments/environment";


export const URL_BACKEND = environment.URL_BACKEND;
export const URL_SERVICIOS = environment.URL_SERVICIOS;
export const URL_FRONTED = environment.URL_FRONTED;

export const SIDEBAR: any = [
  {
    'name': 'Dashboard',
    'permisos': [
      {
        name: 'Graficos',
        permiso: 'show_report_grafics',
      },
    ]
  },
  {
    'name': 'Usuarios',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_user',
      },
      {
        name: 'Listar',
        permiso: 'list_user',
      },
      {
        name: 'Editar',
        permiso: 'edit_user',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_user',
      }
    ]
  },
  {
    'name': 'Roles',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_rol',
      },
      {
        name: 'Listar',
        permiso: 'list_rol',
      },
      {
        name: 'Editar',
        permiso: 'edit_rol',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_rol',
      }
    ]
  },
  {
    name: 'SIAT en Línea',
    permisos: [
      {
        name: 'Configuración SIAT',
        permiso: 'list_siat_configuration',
      },
      {
        name: 'Sucursales SIAT',
        permiso: 'list_siat_branch',
      },
      {
        name: 'Sincronización SIAT',
        permiso: 'list_siat_sync',
      },
      {
        name: 'Eventos SIAT',
        permiso: 'list_siat_event',
      },
    ]
  },
  {
    'name': 'Cuentas Bancarias',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_bank_accounts',
      },
      {
        name: 'Listar',
        permiso: 'list_bank_accounts',
      },
      {
        name: 'Editar',
        permiso: 'edit_bank_accounts',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_bank_accounts',
      }
    ]
  },
  {
    'name': 'Empresas',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_company',
      },
      {
        name: 'Listar',
        permiso: 'list_company',
      },
      {
        name: 'Editar',
        permiso: 'edit_company',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_company',
      }
    ]
  },
  {
    'name': 'Sucursales',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_branch',
      },
      {
        name: 'Listar',
        permiso: 'list_branch',
      },
      {
        name: 'Editar',
        permiso: 'edit_branch',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_branch',
      }
    ]
  },
  {
    'name': 'Almacenes',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_warehouse',
      },
      {
        name: 'Listar',
        permiso: 'list_warehouse',
      },
      {
        name: 'Editar',
        permiso: 'edit_warehouse',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_warehouse',
      }
    ]
  },
  {
    'name': 'Tipo de Cliente',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_customer_type',
      },
      {
        name: 'Listar',
        permiso: 'list_customer_type',
      },
      {
        name: 'Editar',
        permiso: 'edit_customer_type',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_customer_type',
      }
    ]
  },
  {
    'name': 'Clientes',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_customer',
      },
      {
        name: 'Listar',
        permiso: 'list_customer',
      },
      {
        name: 'Editar',
        permiso: 'edit_customer',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_customer',
      }
    ]
  },
  // {
  //   'name': 'Proforma',
  //   'permisos': [
  //     {
  //       name:'Registrar',
  //       permiso: 'register_quotation',
  //     },
  //     {
  //       name:'Listado',
  //       permiso: 'list_quotation',
  //     },

  //     {
  //       name:'Editar',
  //       permiso: 'edit_quotation',
  //     },
  //     {
  //       name:'Eliminar',
  //       permiso: 'delete_quotation',
  //     },
  //   ]
  // },
  {
    'name': 'Venta',
    'permisos': [
      {
        name: 'Registrar Venta',
        permiso: 'register_sale',
      },
      {
        name: 'Listado Venta',
        permiso: 'list_sale',
      },
      // {
      //   name:'Editar',
      //   permiso: 'edit_sale',
      // },
      {
        name: 'Eliminar Venta',
        permiso: 'delete_sale',
      },
      {
        name: 'Registrar Proforma',
        permiso: 'register_quotation',
      },
      {
        name: 'Pagos Anticipos',
        permiso: 'list_down_payment',
      },
      // {
      //   name:'Listado',
      //   permiso: 'list_quotation',
      // },
      {
        name: 'Editar Proforma',
        permiso: 'edit_quotation',
      },
      {
        name: 'Eliminar Proforma',
        permiso: 'delete_quotation',
      },

    ]
  },
  {
    'name': 'Promociones',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_promotion',
      },
      {
        name: 'Listar',
        permiso: 'list_promotion',
      },
      {
        name: 'Editar',
        permiso: 'edit_promotion',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_promotion',
      },
      {
        name: 'Lista de solicitudes',
        permiso: 'list_promotion_petitions',
      }
    ]
  },
  {
    'name': 'Marcas',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_product_brand',
      },
      {
        name: 'Listar',
        permiso: 'list_product_brand',
      },
      {
        name: 'Editar',
        permiso: 'edit_product_brand',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_product_brand',
      }
    ]
  },
  {
    'name': 'Categorias',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_category',
      },
      {
        name: 'Listar',
        permiso: 'list_category',
      },
      {
        name: 'Editar',
        permiso: 'edit_category',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_category',
      }
    ]
  },
  {
    'name': 'Unidades',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_unit',
      },
      {
        name: 'Listar',
        permiso: 'list_unit',
      },
      {
        name: 'Editar',
        permiso: 'edit_unit',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_unit',
      }
    ]
  },
  {
    'name': 'Productos',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_product',
      },
      {
        name: 'Listado',
        permiso: 'list_product',
      },
      {
        name: 'Editar',
        permiso: 'edit_product',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_product',
      },
    ]
  },
  {
    'name': 'Precios',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_price',
      },
      {
        name: 'Editar',
        permiso: 'edit_price',
      },
    ]
  },
  {
    'name': 'Proveedores',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_provider',
      },
      {
        name: 'Listar',
        permiso: 'list_provider',
      },
      {
        name: 'Editar',
        permiso: 'edit_provider',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_provider',
      }
    ]
  },
  {
    'name': 'Compras',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_purchase',
      },
      {
        name: 'Listado',
        permiso: 'list_purchase',
      },
      {
        name: 'Editar',
        permiso: 'edit_purchase',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_purchase',
      },
    ]
  },
  {
    'name': 'Traspasos',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_transfer',
      },
      {
        name: 'Listado',
        permiso: 'list_transfer',
      },
      // {
      //   name:'Editar',
      //   permiso: 'edit_transfer',
      // },
      {
        name: 'Eliminar',
        permiso: 'delete_transfer',
      },
    ]
  },
  {
    name: 'Inventario por Sucursal',
    permisos: [
      {
        name: 'Inventario',
        permiso: 'inventory_warehouse',
      },
      // EDIT
      {
        name: 'Editar tiempo stock mínimo',
        permiso: 'edit_inventory_time_stock_minimum',
      },
      // SHOW
      {
        name: 'Ver CCP Unitario',
        permiso: 'show_inventory_ccp_unit',
      },
      {
        name: 'Ver CCP Total',
        permiso: 'show_inventory_ccp_total',
      },
      {
        name: 'Ver Demanda diaria',
        permiso: 'show_inventory_daily_demand',
      },
      {
        name: 'Ver Días de inventario',
        permiso: 'show_inventory_days_inventory',
      },
      {
        name: 'Ver Meses de inventario',
        permiso: 'show_inventory_months_inventory',
      },
      {
        name: 'Ver Stock mínimo',
        permiso: 'show_inventory_stock_minimum',
      },
      {
        name: 'Ver Cantidad solicitada',
        permiso: 'show_inventory_quantity_requested',
      },
      {
        name: 'Ver Precio venta',
        permiso: 'show_inventory_price_sale',
      },
      {
        name: 'Ver Margen ganancia',
        permiso: 'show_inventory_margin_profit',
      },
    ]
  },
  {
    name: 'Recursos Humanos',
    permisos: [
      {
        name: 'Control de Asistencia',
        permiso: 'list_rrhh_attendance',
      },
    ]
  },
  {
    'name': 'Ajustes de Inventario',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_inventory_adjustment',
      },
      {
        name: 'Listar',
        permiso: 'list_inventory_adjustment',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_inventory_adjustment',
      },
    ]
  },
  {
    'name': 'Kardex',
    'permisos': [
      {
        name: 'Cuantitativo',
        permiso: 'kardex_cuantitativo',
      },
      {
        name: 'Kardex',
        permiso: 'list_kardex',
      },
    ]
  },
  {
    'name': 'Caja',
    'permisos': [
      {
        name: 'Listado',
        permiso: 'list_box',
      },
      {
        name: 'Apertura de caja',
        permiso: 'opening_box',
      },
      {
        name: 'Cierre de caja',
        permiso: 'closing_box',
      },
    ]
  },
  {
    'name': 'Flujo de Caja',
    'permisos': [
      {
        name: 'Registrar',
        permiso: 'register_cash_flow',
      },
      {
        name: 'Listado',
        permiso: 'list_cash_flow',
      },
      {
        name: 'Editar',
        permiso: 'edit_cash_flow',
      },
      {
        name: 'Eliminar',
        permiso: 'delete_cash_flow',
      },
    ]
  },
  {
    'name': 'Finanzas',
    'permisos': [
      {
        name: 'Listar',
        permiso: 'financial_report',
      },
    ]
  },
];

export function isPermission(permission: string) {
  try {
    const userString = localStorage.getItem("user");
    if (!userString || userString === 'undefined' || userString === 'null') {
      return false;
    }

    const USER_AUTH = JSON.parse(userString);

    // 1. Si es Super-Admin, permitir todo
    if (USER_AUTH && USER_AUTH.role && USER_AUTH.role.name === 'Super-Admin') {
      return true;
    }

    // 2. Verificar si tiene el permiso específico
    if (USER_AUTH && USER_AUTH.permissions) {
      if (Array.isArray(USER_AUTH.permissions)) {
        return USER_AUTH.permissions.includes(permission);
      } else if (typeof USER_AUTH.permissions === 'object') {
        // En caso de que permissions sea un objeto en lugar de un array
        return Object.values(USER_AUTH.permissions).includes(permission);
      }
    }

    return false;
  } catch (error) {
    // Si hay un error, simplemente devolvemos false
    return false;
  }
}
